module.exports = __webpack_public_path__ + "img/nvidia-program.8122471f.png";